import { Box, Typography, Theme } from '@mui/material';
import { HTMLAttributes } from 'react';

export type BrokerListItemProps = {
  props: HTMLAttributes<HTMLLIElement>;
  option: {
    value: string;
    email: string;
    label: string;
  };
};

export const BrokerListItem = ({ option, props }: BrokerListItemProps) => {
  return (
    <Box
      component='li'
      {...props}
      key={option.value}
      sx={{
        // white rows with black text on LIO; dark page palettes use the theme's menu colors
        backgroundColor: (theme: Theme) => (theme.palette.theme === 'lio' ? 'white' : undefined),
      }}
    >
      <Typography
        variant='bodySmall'
        sx={{
          color: (theme: Theme) => (theme.palette.theme === 'lio' ? 'common.black' : 'text.main'),
        }}
      >
        {option.label}
        <Typography
          sx={{
            wordBreak: 'break-all',
          }}
          variant='caption'
          fontWeight='normal'
          display='block'
          color='text.subdued'
        >
          {option.email}
        </Typography>
      </Typography>
    </Box>
  );
};
